import api from "./api";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";

// Support tickets, served by profile-erp (/support).
class SupportService {
  // ticket { subject, description, category, priority, attachments: [{ name, url }] }
  create(ticket) {
    return api.post("/support/create/" + currentUserId(), ticket);
  }
  // the tickets of the company (client) or of every company (super admin); status is optional
  list(status) {
    return api.get("/support/list/" + currentUserId(), { params: status ? { status } : {} });
  }
  // ticket with its messages; marks it as read for the connected side
  get(idTicket) {
    return api.get("/support/ticket/" + currentUserId() + "/" + idTicket);
  }
  // message { message, attachments: [{ name, url }] }
  reply(idTicket, message) {
    return api.post("/support/reply/" + currentUserId() + "/" + idTicket, message);
  }
  changeStatus(idTicket, status) {
    return api.put("/support/status/" + currentUserId() + "/" + idTicket, { status });
  }
  unreadCount() {
    return api.get("/support/unreadCount/" + currentUserId());
  }
}

export default new SupportService();
